import axios from 'axios'

export const authenticateItec = async () => {
  const axiosUrl = '/itec/authenticate'
  const { data } = await axios.get(axiosUrl)
  return data
}

export const getPsrPermissions = async (token: string, primarymsisdn: string) => {
  const axiosUrl = `/itec/getPsrPermissions/${primarymsisdn}`
  const { data } = await axios.get(axiosUrl, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  return data
}

export const tokenIdp = async () => {
  const { data } = await axios.get('/idp/token')
  return data
}

export const refCodesParameters = async (body: {}) => {
  const axiosUrl = '/parameter/refCodes'
  const { data } = await axios.post(axiosUrl, body)
  return data
}

export const stlParameters = async (body: {}) => {
  const axiosUrl = '/parameter/stlParameters'
  const { data } = await axios.post(axiosUrl, body)
  return data
}
